module.exports = __webpack_public_path__ + "static/img/geotap-game-lucre-games-ios-android-casual-mobile-game-promo-1.159e7e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/promo/geotap-game-lucre-games-ios-android-casual-mobile-game-promo-1.png
// module id = dZ18
// module chunks = 0